export default function ErrorPage(){
    return <div className="white-text">
        <h1>Waiting for spotify approval</h1>
        <p>This app is still in development mode with Spotify. In order for you to access it I must personally add your spotify account until Spotify approves it. If interested, contact jpoconnell4@wisc.edu.</p>
    </div>
}